import { MtHelp } from "server/models"
import { GET, POST } from "client/store/utils"
import { HelpList } from "./types"


export const LoadHelp = () => (
    GET("/mtHelp/all")
    .then((helpArray: MtHelp[]) => {
        const helpList: HelpList = {}
        helpArray.forEach((help) => {
            helpList[help.route] = help.articleId
        })
        return helpList
    })
)

export const SaveHelp = (help: MtHelp) => (
    POST(
        "/mtHelp/save",
        JSON.stringify(help),
    )
)
